import { IconProps } from '../../types/IconProps';

export const RadioButtonIcon = ({ variant, className }: IconProps) => {
    let innerFill;
    let outerFill;
    switch (variant) {
        case 'light':
            innerFill = '#fff';
            outerFill = '#0B223E';
            break;
        case 'dark':
            innerFill = '#0B223E';
            outerFill = '#fff';
            break;
        default:
            innerFill = '#fff';
            outerFill = '#0B223E';
    }
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 20 20'
            fill='none'
            className={`${className || ''}`}>
            <rect className={`${className}`} width="20" height="20" rx="10" fill={outerFill}/>
            <path fill={innerFill} fillRule="evenodd" clipRule="evenodd" d="M10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z"/>
        </svg>
    );
};

